export enum Features {
  CROSS_COVERAGE = 'cross_coverage',
  MAINTENANCE = 'fieldops-web-maintenance-mode',
  OWNER_FACING_COMMENTS = 'field-ops-enable-owner-facing-comments',
  OWNER_FACING_TICKETS = 'field-ops-owner-facing-tickets',
}
